const CAPTURE_SIGNAL = /screenshot|스크린샷/i;

const bytesToAscii = bytes => String.fromCharCode(...bytes);

const readBytes = async (file, start, end) =>
  new Uint8Array(await file.slice(start, end).arrayBuffer());

const hasCaptureMetadata = async file => {
  try {
    const signature = await readBytes(file, 0, 8);
    if (bytesToAscii(signature.subarray(1, 4)) !== 'PNG') return false;

    let offset = 8;
    while (offset < file.size) {
      const header = await readBytes(file, offset, offset + 8);
      const length = new DataView(header.buffer).getUint32(0, false);
      const type = bytesToAscii(header.subarray(4, 8));
      if (type === 'eXIf') {
        const chunk = await readBytes(file, offset + 8, offset + 8 + length);
        return CAPTURE_SIGNAL.test(bytesToAscii(chunk));
      }
      if (type === 'IDAT') return false;

      offset += 12 + length;
    }
    return false;
  } catch {
    return false;
  }
};

export default async function isCaptureImage(file) {
  if (await hasCaptureMetadata(file)) return true;

  return CAPTURE_SIGNAL.test(file.name.normalize('NFC'));
}
